/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { UxpageUp } from '../../models/uxpage-up';

export interface GetNavigation$Params {
}

export function getNavigation(http: HttpClient, rootUrl: string, params?: GetNavigation$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<UxpageUp>>> {
  const rb = new RequestBuilder(rootUrl, getNavigation.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<UxpageUp>>;
    })
  );
}

getNavigation.PATH = '/api/Navigation/list';
